import { getNotificationsConfig } from '@repo/catalogs-services'
import { defineSagaForService } from '@repo/core'
import {
  accountsNotificationsCatalogActions,
  commonNotificationsCatalogActions,
  mailboxNotificationsCatalogActions,
  positionNotificationsCatalogActions,
  toolsNotificationsCatalogActions,
  userNotificationsCatalogActions,
} from '../../slices'
import { createConfig } from '../generators'

export const loadNotificationsCatalogServiceConfig = defineSagaForService({
  [accountsNotificationsCatalogActions.getRequest.type]: createConfig(
    accountsNotificationsCatalogActions.getResponse,
    getNotificationsConfig,
    accountsNotificationsCatalogActions.getRequest,
  ),
  [positionNotificationsCatalogActions.getRequest.type]: createConfig(
    positionNotificationsCatalogActions.getResponse,
    getNotificationsConfig,
    positionNotificationsCatalogActions.getRequest,
  ),
  [toolsNotificationsCatalogActions.getRequest.type]: createConfig(
    toolsNotificationsCatalogActions.getResponse,
    getNotificationsConfig,
    toolsNotificationsCatalogActions.getRequest,
  ),
  [commonNotificationsCatalogActions.getRequest.type]: createConfig(
    commonNotificationsCatalogActions.getResponse,
    getNotificationsConfig,
    commonNotificationsCatalogActions.getRequest,
  ),
  [userNotificationsCatalogActions.getRequest.type]: createConfig(
    userNotificationsCatalogActions.getResponse,
    getNotificationsConfig,
    userNotificationsCatalogActions.getRequest,
  ),
  [mailboxNotificationsCatalogActions.getRequest.type]: createConfig(
    mailboxNotificationsCatalogActions.getResponse,
    getNotificationsConfig,
    mailboxNotificationsCatalogActions.getRequest,
  ),
})
